import { render } from "./pedidoComponent.vue?vue&type=template&id=c7dfea3e"
import script from "./pedidoComponent.vue?vue&type=script&lang=js"
export * from "./pedidoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__